import { render, staticRenderFns } from "./MinimalistMode.vue?vue&type=template&id=7ec0570e&scoped=true&"
import script from "./MinimalistMode.vue?vue&type=script&lang=js&"
export * from "./MinimalistMode.vue?vue&type=script&lang=js&"
import style0 from "./MinimalistMode.vue?vue&type=style&index=0&id=7ec0570e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0570e",
  null
  
)

export default component.exports